// @flow
import styled from '@emotion/styled'
import * as React from 'react'

import { colors, media } from '@toggl/style'

import * as text from '../text'

type Props = {|
  +children?: React.Node,
  +className?: string,
  +description: string,
  +image: React.Node,
  +label?: string,
  +title: string,
|}

export default function ImageTextSimple({
  children,
  className,
  description,
  image,
  label,
  title,
}: Props) {
  return (
    <Root className={className}>
      <ImageWrapper>
        {label && <Label>{label}</Label>}
        {image}
      </ImageWrapper>
      <TextWrapper>
        <Title color={colors.darkPurple}>{title}</Title>
        <text.P3 color={colors.fadedPurple}>{description}</text.P3>
        {children}
      </TextWrapper>
    </Root>
  )
}

const Root: React.ComponentType<any> = styled.div`
  display: flex;

  ${media.mq[2]} {
    flex-direction: column;
  }
`

const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background-color: white;
  margin-bottom: 10px;
  width: 30%;
  max-width: 140px;
  height: 90px;

  ${media.mq[2]} {
    max-width: none;
    width: 100%;
    height: 180px;
    position: relative;
  }

  img {
    object-fit: contain;
  }
`

const TextWrapper = styled.div`
  margin-left: 15px;
  align-self: center;

  ${media.mq[2]} {
    margin-left: 0;
    margin-top: 15px;
    align-self: flex-start;
  }
`

const Title = styled(text.P2)`
  font-weight: bold;
  margin-bottom: 5px;
`

const Label = styled.span`
  display: none;
  ${media.mq[2]} {
    display: block;
    ${text.paragraph4};
    background-color: ${({ theme }) => theme.accent};
    color: ${colors.darkPurple};
    position: absolute;
    top: 15px;
    right: 15px;
  }
`
